module.exports = __webpack_public_path__ + "static/img/efim.d8c8a00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/efim.jpg
// module id = 245
// module chunks = 1